import { render } from "./base-underline-tabs.vue?vue&type=template&id=5fcbe295"
import script from "./base-underline-tabs.vue?vue&type=script&lang=js"
export * from "./base-underline-tabs.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__